import React from 'react';
import { useUserInfo } from '@repository/auth/useUserInfo';
import Tooltip from '../../../tooltip';
import { PaccProfileResultVO } from '@domain/vo/phs/pacc/competence/PaccProfileResultVO';
import { competenceProfileMap } from '@domain/constant/competenceType';
import classNames from 'classnames/bind';
import styles from './competencyHeader.module.scss';

const cx = classNames.bind(styles);

const tooltipContent = (
  <>
    <em>역량유형이란?</em>
    <p>응시자님의 역검 결과를 바탕으로 총 12가지 역량유형 중 가장 잘 맞는 유형을 보여줍니다.</p>
    <p>
      나에게 해당하는 유형이 어떤 모습을 가지고 있는지, 어떤 직장 생활을 하게 될지 예상해보고, 직장생활에서 함께
      시너지를 낼 수 있는 다른 유형도 확인해보세요.
    </p>
  </>
);

interface CompetencyHeaderProps {
  paccProfileResult: PaccProfileResultVO;
}

const CompetencyHeader = ({ paccProfileResult }: CompetencyHeaderProps) => {
  const { data: userInfo } = useUserInfo();
  const userName = userInfo?.name ?? '';

  const { type, name, img, catchPhrase, description } = competenceProfileMap[paccProfileResult.type];
  const typeName = `${name}은 어떤 모습을 가지고 있을까요?`;

  return (
    <>
      <div className={cx('titleArea')}>
        <div className={cx('titleWrap')}>
          <div className={cx('infoArea')}>
            <span className={cx('infoText')}>{userName}님의 역량 유형은?</span>
            <Tooltip type={'competency'} content={tooltipContent} />
          </div>
          <span className={cx('typeTitle')}>
            {userName}님의
            <br />
            역량유형:
          </span>
          <span className={cx('type')}>{name}</span>
          <span className={cx('typeEnglish')}>{type}</span>
        </div>

        <div className={cx('joyWrap')}>
          <div className={cx('joyImg')} style={{ backgroundImage: `url(/img/components/acca/test/result${img})` }} />
          <div className={cx('commentWrap')}>
            <div className={cx('comment')}>{catchPhrase}</div>
          </div>
        </div>
      </div>

      <div className={cx('descArea')}>
        <em className={cx('title')}>{typeName}</em>
        <p className={cx('desc')}>{description}</p>
      </div>
    </>
  );
};

export default CompetencyHeader;
